<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M29.82 46.24a1 1 0 00.68.26 1 1 0 00.69-.28l10.5-10a1 1 0 00-1.38-1.44l-9.82 9.35-4.81-4.43a1 1 0 10-1.36 1.47z"/><path d="M49 27h-3v-4a14 14 0 00-28 0v4h-3a2 2 0 00-2 2v24a2 2 0 002 2h34a2 2 0 002-2V29a2 2 0 00-2-2zm-28-4a11 11 0 0122 0v4H21zm27 29H16V30h32z"/></svg>